uvex-product-stream-slider {
  display: block;
  position: relative;
  margin-bottom: 2rem;
  min-height: 300px;
}
